// import React from 'react';
import { createSelector } from "reselect";
import ls from "local-storage";
import config from "../constants/config";
import {
  formatEq,
  getTotal,
  hasAchieved,
  getOldGridList,
  // getGridData,
} from "../utils/gameHelpers";

const getApp = (state) => state.app;
const getGame = (state) => state.game;

export const getEquation = createSelector([getGame], (game) =>
  game.eq.slice(0, game.eqPos)
);
export const getFormattedEquation = createSelector([getEquation], (equation) =>
  formatEq(equation)
);
export const getEquationTotal = createSelector([getEquation], (equation) =>
  getTotal(equation)
);
export const getIsComplete = createSelector(
  [getEquationTotal, getGame],
  (total, game) => game.target === total && total > 0
);
export const getSolutions = createSelector(
  [getApp, getGame],
  (app, game) => game.solutions // TODO: local storage
);
export const getShowReset = createSelector(getGame, (game) => game.eqPos > 0);
export const getShowUndo = createSelector([getGame], (game) => game.eqPos > 0);
export const getShowRedo = createSelector(
  [getGame],
  (game) => game.eqPos < game.eq.length
);
export const getGridWidth = createSelector([getApp], (app) =>
  app.screenWidth > config.desktop ? 800 : app.screenWidth - 22
);

const getHeightDiff = (w) => {
  if (w >= 1920) return 305;
  else if (w >= 1280) return 250;
  else if (w >= 960) return 275;
  else if (w >= 600) return 250;
  return 235;
};

export const getGridHeight = createSelector(
  [getApp],
  (app) =>
    app.screenHeight -
    getHeightDiff(app.screenWidth) -
    (app.equationDiv ? app.equationDiv.clientHeight : 0)
);
export const getTileWidth = createSelector(
  [getGridWidth, getGridHeight, getGame],
  (gridWidth, gridHeight, game) =>
    Math.max(
      40,
      Math.min(
        Math.floor(gridHeight / (game.rows + 1)) - 4,
        Math.floor(gridWidth / game.cols) - config.padding
      )
    )
);
export const getOpWidth = createSelector(
  [getTileWidth, getGridWidth],
  (tileWidth, gridWidth) =>
    Math.min(
      tileWidth,
      Math.floor(gridWidth / config.operators.length) - config.padding
    )
);

export const getAchievements = createSelector(
  [getGame, getSolutions],
  (game, solutions) =>
    config.achievements.map((achievement) => ({
      ...achievement,
      achieved: hasAchieved(achievement, solutions, game.target, game.grid),
    }))
);
export const getAchievementCount = createSelector(
  [getAchievements],
  (achievements) => achievements.filter((a) => a.achieved).length
);
export const getMessage = createSelector(
  [getGame, getAchievementCount, getIsComplete],
  (game, achievementCount, isComplete) =>
    isComplete
      ? {
          solved: true,
          achievements: game.achievementDiff,
          solutionNew: game.solutionNew,
        }
      : false
);
export const getHighlightAchievements = createSelector(
  [getGame],
  (game) => game.achievementDiff.length > 0
);
export const getShowTitleScreen = createSelector(
  [getApp, getGame],
  (app, game) => app.titleScreen || game.grid.length === 0
);
export let grids = [];
// document.addEventListener("deviceready", () => {
// console.log("grids ready", grids);
// });

const getGrids = () => {
  // console.log("getOldGridList type", typeof getOldGridList);
  const newGrids = ls("grids") || getOldGridList() || [];
  // console.log("newGrids", newGrids);
  if (newGrids.join(";;") !== grids.join(";;")) {
    grids = newGrids;
  }
  return grids;
};
// ls.on("grids", (newGrids) => {
//   console.log("ON GRIDS", newGrids);
//   grids = newGrids;
// });
export const getHistoryGrids = createSelector(
  [getGrids],
  (g) => g
  // getOldGridList().filter((a) => ls(a).solutions)
);

// console.log(localStorage);

export const getHistoryAchievements = createSelector(
  [getGame, getAchievements, getSolutions, getHistoryGrids],
  (game, achievements, solutions, grids) => [
    ...grids
      .filter((d) => d !== `${game.target},${game.grid.join(",")}`)
      .map((data) => ({
        target: parseInt(data.split(",")[0], 10),
        grid: data.split(",").slice(1),
        solutions: ls(data).solutions,
        achievements: config.achievements.map((achievement) => ({
          ...achievement,
          achieved: hasAchieved(
            achievement,
            ls(data).solutions,
            parseInt(data.split(",")[0], 10),
            data.split(",").slice(1)
          ),
        })),
      }))
      .filter(
        (d) =>
          !(
            d.target === game.target &&
            d.grid
              .slice(0)
              .sort((a, b) => a - b)
              .join(",") ===
              game.grid
                .slice(0)
                .sort((a, b) => a - b)
                .join(",")
          )
      ),
    {
      target: game.target,
      grid: game.grid,
      solutions,
      achievements,
    },
  ]
);
